import { render, staticRenderFns } from "./IframeRedirectOverlay.vue?vue&type=template&id=17a2a4bc&scoped=true"
import script from "./IframeRedirectOverlay.vue?vue&type=script&lang=js"
export * from "./IframeRedirectOverlay.vue?vue&type=script&lang=js"
import style0 from "./IframeRedirectOverlay.vue?vue&type=style&index=0&id=17a2a4bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_@vue+compiler-sfc@_1ea54a5d08821f18e5f7625cad052d96/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a2a4bc",
  null
  
)

export default component.exports